import { Component, Inject, OnInit } from '@angular/core';
import { AccountingResource, AccountingSystemDetails } from '@apaq/orgkit-js';
import { DialogRef } from 'src/app/modules/dialog/dialog-ref';
import { DATA, DIALOG } from 'src/app/modules/dialog/dialog.service';
import { container } from 'tsyringe';
import { ConnectDetails } from '../../accounting-view.component';

@Component({
  selector: 'app-economic-connection-dialog',
  templateUrl: './economic-connection-dialog.component.html',
  styleUrls: ['./economic-connection-dialog.component.scss']
})
export class EconomicConnectionDialogComponent implements OnInit {

  systemKey = '';

  constructor(@Inject(DIALOG) private dialog: DialogRef,
  @Inject(DATA) private data: ConnectDetails,
  private accountingResource: AccountingResource) { }
  
  ngOnInit(): void {
  }

  close() {
    this.dialog.close();
  }

  async connect() {
    const details: AccountingSystemDetails = {id: null!, key: this.systemKey!, system: 'Economic'};
    try {
      await this.accountingResource.checkAccountingBackend(details);
    } catch(error) {
      Stallion.alert($localize`Cannot connect to Economic with the specified company id and api key.`, 'warning');
      return;
    }
    this.dialog.close(details);
  }
}
